export default function(css) {
    if (css.indexOf('.css') !== -1) {
        return `<link rel="stylesheet" type="text/css" href="${css}">`;
    } else {
        return `<style type="text/css">${css}</style>`;
    }
}